import { Component, OnInit} from "@angular/core";
import { TreinFormService } from "../services/trein-form.service";
import { Router } from "@angular/router";
import { OLMapService } from "src/app/services/ol-map/ol-map.service";
import { TreinMapService } from "../services/trein-map.service";
import { AtlasFilterBaseComponent } from "src/app/components/ol-map/ol-map-filters/atlas-filter-base.component";
import { DatasetEntry } from "src/app/models/dataset-entry";
import { TREIN_FILTER_LABELS, TREIN_OPTIONS } from "src/assets/constants/constants";
import { faTimes as falTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import { faFilter as falFilter } from "@fortawesome/free-solid-svg-icons/faFilter";
import { faSpinner as falSpinnerThird } from "@fortawesome/free-solid-svg-icons/faSpinner";
import { debounceTime } from "rxjs/operators";

@Component({
  standalone: false,
  selector: "app-atlas-trein-filter",
  templateUrl: "./atlas-trein-filter.component.html",
  styleUrls: ["./atlas-trein-filter.component.scss"] })
export class AtlasTreinFilterComponent
  extends AtlasFilterBaseComponent
  implements OnInit
{
  get form() {
    return this.formService.form;
  }
  public parameters: any;
  readonly icons = {
    falTimes,
    falSpinnerThird,
    falFilter };
  public readonly options = TREIN_OPTIONS;
  public formLabels = TREIN_FILTER_LABELS
  constructor(
    private formService: TreinFormService,
    private readonly router: Router,
    public readonly olMapService: OLMapService,
    private readonly treinMapService: TreinMapService,
  ) {
    super();
  }
  ngOnInit() : void{
    this.subscriptions.push(this.form.valueChanges.pipe(debounceTime(150)).subscribe((value) => {
      this.updateRoute(value);
    }));
  }
  updateRoute(value: any): void {
    this.router.navigate([], {
      queryParamsHandling: "merge",
      queryParams: value,
    });
    this.treinMapService.loadLayer();
  }  setFilter(filter: string, value: any) {}
  changeDataset(entry: DatasetEntry) {}
}



